/**
 * @license
 *
 * Copyright IBM Corp. 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './pricing-table';
import './pricing-table-head';
import './pricing-table-header-row';
import './pricing-table-header-cell';
import './pricing-table-header-cell-cta';
import './pricing-table-header-cell-description';
import './pricing-table-header-cell-headline';
import './pricing-table-header-cell-caption';
import './pricing-table-header-cell-tag';
import './pricing-table-highlight-label';
import './pricing-table-body';
import './pricing-table-group';
import './pricing-table-row';
import './pricing-table-cell';
import './pricing-table-cell-annotation';
import './pricing-table-annotation-toggle';
